import type { IBaseFloatingSuggestionsProps } from '../FloatingSuggestions.types';
import type { IPersonaProps } from '@fluentui/react/lib/Persona';

export type IFloatingPeopleSuggestionsProps = IBaseFloatingSuggestionsProps<IPersonaProps>;
